import React, { useState } from 'react'
import { Button } from '../../../helpers'

const CloseTicketConfirmation = (props) => {
    const { verifyInvoice } = props

    const handleVerifyPIAndCloseTicket = () => {
        verifyInvoice(true)
    }

    return (
        <div>
            <div className="flex flex-row justify-content-center mt-5">
                An open ticket has been found. Would you like to close it?
            </div>
            <div className="flex flex-row justify-content-center mt-5">
                <Button label="Verify Invoice & Close Ticket" onClick={handleVerifyPIAndCloseTicket} />
                <Button className="ml-2" label="Verify Invoice Only" onClick={() => verifyInvoice(false)} />
            </div>
        </div>
    )
}

export default CloseTicketConfirmation
